/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllMatrixCareHomeHealthAdmissionsResponse } from './FindAllMatrixCareHomeHealthAdmissionsResponse';
import {
    FindAllMatrixCareHomeHealthAdmissionsResponseFromJSON,
    FindAllMatrixCareHomeHealthAdmissionsResponseFromJSONTyped,
    FindAllMatrixCareHomeHealthAdmissionsResponseToJSON,
    FindAllMatrixCareHomeHealthAdmissionsResponseToJSONTyped,
} from './FindAllMatrixCareHomeHealthAdmissionsResponse';

/**
 * 
 * @export
 * @interface FindAllMatrixCareHomeHealthAdmissions200Response
 */
export interface FindAllMatrixCareHomeHealthAdmissions200Response {
    /**
     * 
     * @type {FindAllMatrixCareHomeHealthAdmissionsResponse}
     * @memberof FindAllMatrixCareHomeHealthAdmissions200Response
     */
    data?: FindAllMatrixCareHomeHealthAdmissionsResponse;
}

/**
 * Check if a given object implements the FindAllMatrixCareHomeHealthAdmissions200Response interface.
 */
export function instanceOfFindAllMatrixCareHomeHealthAdmissions200Response(value: object): value is FindAllMatrixCareHomeHealthAdmissions200Response {
    return true;
}

export function FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON(json: any): FindAllMatrixCareHomeHealthAdmissions200Response {
    return FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllMatrixCareHomeHealthAdmissions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllMatrixCareHomeHealthAdmissionsResponseFromJSON(json['data']),
    };
}

export function FindAllMatrixCareHomeHealthAdmissions200ResponseToJSON(json: any): FindAllMatrixCareHomeHealthAdmissions200Response {
    return FindAllMatrixCareHomeHealthAdmissions200ResponseToJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthAdmissions200ResponseToJSONTyped(value?: FindAllMatrixCareHomeHealthAdmissions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllMatrixCareHomeHealthAdmissionsResponseToJSON(value['data']),
    };
}

